module.exports = __webpack_public_path__ + "static/redcap-196acdc7327c7606904d2bf29a470463.jpg";